import { useListingReviewCardContext } from "./ListingReviewCardProvider";
import { ScoreStarRating } from "../../../../global/score/material";

export const ListingReviewScore = () => {
  const { state } = useListingReviewCardContext();

  return <ScoreStarRating value={state.review.score} />;
};
